// tools/export.js
import axios from 'axios';
import qs from 'qs';

/**
 * 公共导出工具类
 */
class ExportUtil {
  /**
   * 执行导出
   * @param {Object} options 配置选项
   */
  static execute(options) {
    return new Promise((resolve, reject) => {
      this._executeExport(options)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static _executeExport(options) {
    const apiPath = options.apiPath;
    const exportParams = options.exportParams;
    const filename = options.filename || '';
    const getAuthHeaders = options.getAuthHeaders;
    const onSuccess = options.onSuccess;
    const onError = options.onError;

    console.log('开始导出:', { apiPath: apiPath, exportParams: exportParams });

    // 构建请求配置
    const apiHost = ($config && $config.apihost) || '';
    const url = apiHost + '/api.php?r=' + apiPath;

    // 获取认证头信息
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    if (getAuthHeaders) {
      const authHeaders = getAuthHeaders();
      if (authHeaders) {
        Object.assign(headers, authHeaders);
      }
    }

    const config = {
      method: 'post',
      url: url,
      data: qs.stringify(exportParams),
      headers: headers,
      responseType: 'blob',
      timeout: 60000
    };

    return axios(config).then((response) => {
      if (response.status !== 200) {
        throw new Error('请求失败，状态码: ' + response.status);
      }

      if (!response.data || response.data.size === 0) {
        throw new Error('导出的文件为空');
      }

      // 检查是否是错误响应
      const contentType = response.headers['content-type'];
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return this._readBlobAsText(response.data).then((errorText) => {
          let errorData;
          try {
            errorData = JSON.parse(errorText);
            throw new Error(errorData.msg || errorData.error || '导出失败');
          } catch (e) {
            throw new Error(errorText || '导出失败');
          }
        });
      }

      // 生成文件名
      const timestamp = new Date().getTime();
      const finalFilename = filename || '导出数据_' + timestamp + '.xls';

      // 下载文件
      this._downloadFile(response.data, finalFilename);
      
      if (onSuccess) {
        onSuccess('导出成功');
      }
      return true;

    }).catch((error) => {
      console.error('导出错误:', error);
      return this._handleExportError(error).then((errorMessage) => {
        if (onError) {
          onError(errorMessage);
        }
        throw new Error(errorMessage);
      });
    });
  }

  /**
   * 下载文件
   */
  static _downloadFile(blobData, filename) {
    const blob = new Blob([blobData], { 
      type: 'application/vnd.ms-excel' 
    });
    
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  }

  /**
   * 处理导出错误
   */
  static _handleExportError(error) {
    let errorMessage = '导出失败';
    
    if (error && error.response) {
      if (error.response.data instanceof Blob) {
        return this._readBlobAsText(error.response.data).then((errorText) => {
          return this._parseErrorMessage(errorText);
        });
      } else {
        errorMessage = (error.response.data && error.response.data.message) || error.response.statusText || errorMessage;
        return Promise.resolve(errorMessage);
      }
    } else if (error && error.message) {
      errorMessage = error.message;
      return Promise.resolve(errorMessage);
    } else {
      return Promise.resolve(errorMessage);
    }
  }

  /**
   * 读取 Blob 为文本
   */
  static _readBlobAsText(blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        resolve('无法读取错误信息');
      };
      reader.readAsText(blob);
    });
  }

  /**
   * 解析错误信息
   */
  static _parseErrorMessage(errorText) {
    try {
      const errorData = JSON.parse(errorText);
      return errorData.msg || errorData.error || errorText;
    } catch (e) {
      return errorText || '导出失败';
    }
  }

  /**
   * 构建导出参数（过滤分页和排序参数）
   */
  static buildExportParams(searchParams, excludeFields = []) {
    const exportParams = {};
    const defaultExclude = ['_page', '_size', '_order', '_isreverse'];
    const allExclude = defaultExclude.concat(excludeFields);
    
    Object.keys(searchParams).forEach((key) => {
      if (allExclude.indexOf(key) === -1) {
        exportParams[key] = searchParams[key];
      }
    });
    
    return exportParams;
  }
}

export default ExportUtil;